import { render, staticRenderFns } from "./add-outside-request-seller.modal.vue?vue&type=template&id=28bfb363&scoped=true"
import script from "./add-outside-request-seller.modal.vue?vue&type=script&lang=js"
export * from "./add-outside-request-seller.modal.vue?vue&type=script&lang=js"
import style0 from "./add-outside-request-seller.modal.vue?vue&type=style&index=0&id=28bfb363&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfb363",
  null
  
)

export default component.exports